<template>
  <!-- 购物车商品分析 -->
  <div class="shopCart">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['用户分析', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">日期范围：</label>
        <el-select
          placeholder="日期范围"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.type"
        >
          <el-option label="全部数据" value="0"></el-option>
          <el-option label="自定义" value="9"></el-option>
          <el-option label="今天" value="1"></el-option>
          <el-option label="昨天" value="2"></el-option>
          <el-option label="近7天" value="3"></el-option>
          <el-option label="近30天" value="4"></el-option>
          <el-option label="本月" value="5"></el-option>
          <el-option label="本季度" value="6"></el-option>
          <el-option label="半年" value="7"></el-option>
          <el-option label="本年" value="8"></el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.start"
          style="margin-right: 5px"
          type="date"
          v-show="searchForm.type == 9"
          clearable
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.end"
          style="margin-right: 5px"
          type="date"
          v-show="searchForm.type == 9"
          clearable
          placeholder="选择截至日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入关键字"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="sort"
        show-overflow-tooltip
        label="排名"
      >
      </el-table-column>
      <el-table-column
        prop="number"
        align="center"
        show-overflow-tooltip
        label="购物车商品数"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="产品名"
      >
      </el-table-column>
      <el-table-column
        prop="specification"
        align="center"
        show-overflow-tooltip
        label="规格"
      >
      </el-table-column>
      <el-table-column
        prop="SFDA"
        align="center"
        show-overflow-tooltip
        label="国药准字"
      >
      </el-table-column>
      <el-table-column
        prop="productor"
        align="center"
        show-overflow-tooltip
        label="生产公司"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "shopCart",
  data() {
    return {
      /**表格数据 */
      // {
      //   sort:"排序",
      //   number:"购物车商品数",
      //   name:"产品名",
      //   specification:"规格",
      //   SFDA:"国药准字",
      //   productor:"生产公司"
      // }
      tableData: [],
      /**搜索表单 */
      searchForm: {
        start: "",
        type: "0",
        end: "",
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData() {
      let data = {
        type: "Pc_CartProductSearch",
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strWhere: this.searchForm.name,
        datetype: this.searchForm.type || "0",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          // if(res.flag == 0){
          //   this.allPage = res.recordCount
          //   this.tableData = res.data.map(item => ({
          //     number: item.Num,
          //     keywords: item.SearchValue
          //   }))
          // }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.shopCart {
  width: 100%;
  height: 100%;
}
</style>
